<div class="carousel_Container">
  <!-- Tabs -->
  <!--Tab headings-->
  <div class="carousel_Headings">
    @for(item of mergedObject1; track $index){
      <div class="tab" [class.active]="activeIndex === $index" (click)="setActive($index)">
        <span class="heading_Txt">{{ item?.Heading }} </span>
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M15.2385 16.0798C15.128 16.1828 15.0393 16.307 14.9778 16.445C14.9163 16.583 14.8833 16.732 14.8806 16.8831C14.8779 17.0341 14.9057 17.1842 14.9623 17.3242C15.0189 17.4643 15.1031 17.5916 15.2099 17.6984C15.3168 17.8052 15.444 17.8894 15.5841 17.946C15.7242 18.0026 15.8742 18.0304 16.0253 18.0277C16.1763 18.0251 16.3253 17.992 16.4633 17.9305C16.6013 17.869 16.7255 17.7804 16.8285 17.6698L21.7035 12.7948L22.5 11.9998L21.705 11.2048L16.83 6.32985C16.6179 6.12482 16.3338 6.01129 16.0388 6.01371C15.7438 6.01613 15.4616 6.13432 15.2529 6.3428C15.0443 6.55129 14.9258 6.8334 14.9231 7.12837C14.9204 7.42334 15.0337 7.70757 15.2385 7.91985L18.1935 10.8748H2.625C2.32663 10.8748 2.04048 10.9934 1.8295 11.2044C1.61853 11.4153 1.5 11.7015 1.5 11.9998C1.5 12.2982 1.61853 12.5844 1.8295 12.7953C2.04048 13.0063 2.32663 13.1248 2.625 13.1248H18.1935L15.2385 16.0798Z"
              fill="#2A3237" />
          </svg>
        </span>
      </div>
    }
  </div>
  <!--Tabs content-->
  <div class="carousel_Content">
    @for(item of mergedObject1; track $index){
      @if(activeIndex === $index){
        <div class="carousel_slide" [class.third-tab]="$index === 2" [class.first-tab]="$index === 0">
          <div class="tab_Section1">
            <!--Tab 1 starts from here-->
            @if(item?.firstCOMP){
              <div class="section1_Wrapper">
                <div class="textcontainer1">
                  <div class="left_Container">
                    @if(item?.firstCOMP?.textPageContent2){
                      <div [innerHTML]="item?.firstCOMP?.textPageContent2" class="text_1"></div>
                    }
                    <!--Product Summary Link-->
                    @if(item?.firstCOMP?.linkText){
                      <div class="summary_Link">
                        <a class="summaryofproductuk" (click)="openExternalLinkModal()">
                          <span [innerHTML]="item?.firstCOMP?.linkText"></span>
                          <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path
                                d="M20 9.33333V4H14.6667M20 4L10.2222 13.7778M17.3333 12.8889V18.2222C17.3333 18.6937 17.146 19.1459 16.8126 19.4793C16.4792 19.8127 16.0271 20 15.5556 20H5.77778C5.30628 20 4.8541 19.8127 4.5207 19.4793C4.1873 19.1459 4 18.6937 4 18.2222V8.44444C4 7.97295 4.1873 7.52076 4.5207 7.18737C4.8541 6.85397 5.30628 6.66667 5.77778 6.66667H11.1111"
                                stroke="#EA181B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </span>
                        </a>
                      </div>
                    }
                  </div>
                  <!--Tivc tab 1 image-->
                  @if(item?.firstCOMP?.media){
                  <div class="image_Container" class="tivc_Image">
                    <img [src]="getImage(item?.firstCOMP?.media)" alt="item?.firstCOMP?.altText" class="carousel_Image" />
                  </div>
                  }
                </div>
              </div>
              @if(item?.firstCOMP?.PageSubText){
                  <div class="text_Container2">
                    <div [innerHTML]="item?.firstCOMP?.PageSubText" class="text_subContainer"></div>
                  </div>
              }
            }
            <!--ativ tab1 image and text container-->
            @if(item?.firstCOMP?.media && item?.firstCOMP?.TextPage2){
              <div class="image_Outer_Container">
                <div class="image_Container" class="ativ_Image">
                  <img [src]="getImage(item?.firstCOMP?.media)" alt="item?.firstCOMP?.desktop.altText"
                    class="carousel_Image" />
                </div>

                <div [innerHTML]="item?.firstCOMP?.TextPage2" class="textPage2"></div>
              </div>
            }
            <!-- Tab 1 ends above-->
            <!--Tab 2 content starts from here-->
            @if(item?.secondCOMP?.textPageContent1){
              <div [innerHTML]="item?.secondCOMP?.textPageContent1" class="textContent1"></div>
            }
            @if(item?.secondCOMP?.media){
              <img [src]="getImage(item?.secondCOMP?.media)" class="ativ_SecondTab_Img" [alt]="item?.secondCOMP?.media.desktop.altText">
            }
            @if(item?.secondCOMP?.textPageContent2){
              <div [innerHTML]="item?.secondCOMP?.textPageContent2" class="ativ_Tab2_Txt"></div>
            }
            @if(item?.secondCOMP?.headLine1){
               <div [innerHTML]="item?.secondCOMP?.headLine1" class="ativ_Tab2_Txt ajm_Tab2_Txt"></div>
            }
            @if(item?.secondCOMP?.image){
               <img [src]="getImage1(item?.secondCOMP?.image)" [alt]="item?.secondCOMP?.image.code" class="ativ_SecondTab_Img ajm_Tab2_Img">
            }
            @if(item?.secondCOMP?.textPageContent3){
               <div [innerHTML]="item?.secondCOMP?.textPageContent3" class="ajm_Tab2_subTxt ajm_Tab2_Txt"></div>
            }
            <!--Tab 2 ends above-->
            <!-- tab 3 content starts from here-->
            @if(item?.fourthCOMP?.vaccineInfoFeaturedResourcesfactor){
              @for(factor of factorData; track $index){
                <div class="tab3_OuterContainer">
                  <div class="heading_Container_Ativ">
                    @if(factor?.media){
                      <img [src]="getImage(factor?.media)">
                    }
                    @if(factor?.headline1){
                      <div [innerHTML]="factor?.headline1" class="blue_Txt color_Heading"></div>
                    }
                  </div>
                  <div [innerHTML]="factor?.PAgeParacontent1" class="tab3_PageContent"></div>
                </div>
              }
            }
            <!--Tab 3 ends above-->
          </div>
        </div>
      }
    }
  </div>
</div>
